export const EXEMPT_REASONS = {
  TECHNICAL_DIFFICULTIES: 'technical_difficulties',
  CONTENT_INCORRECT: 'content_incorrect', 
  CONTENT_IRRELEVANT: 'content_irrelevant',
  SKILL_DEMONSTRATED_ELSEWHERE: 'skill_demonstrated_elsewhere',
  OTHER: 'other'
};

export const EXEMPT_REASON_LABELS = {
  [EXEMPT_REASONS.TECHNICAL_DIFFICULTIES]: 'Technical difficulties block completion',
  [EXEMPT_REASONS.CONTENT_INCORRECT]: 'Content is incorrect',
  [EXEMPT_REASONS.CONTENT_IRRELEVANT]: 'Content is irrelevant', 
  [EXEMPT_REASONS.SKILL_DEMONSTRATED_ELSEWHERE]: 'Skill has been demonstrated elsewhere',
  [EXEMPT_REASONS.OTHER]: 'Other'
};

export const PREDEFINED_REASONS = [
  EXEMPT_REASONS.TECHNICAL_DIFFICULTIES,
  EXEMPT_REASONS.CONTENT_INCORRECT,
  EXEMPT_REASONS.CONTENT_IRRELEVANT,
  EXEMPT_REASONS.SKILL_DEMONSTRATED_ELSEWHERE
];

export const formatExemptReason = (reason, customText = '') => {
  if (reason === EXEMPT_REASONS.OTHER && customText?.trim()) {
    return `${EXEMPT_REASONS.OTHER}:${customText.trim()}`;
  }
  return reason || '';
};

export const parseExemptReason = (storedReason) => {
  if (!storedReason) {
    return { reason: '', customText: '' };
  }

  if (storedReason.startsWith(`${EXEMPT_REASONS.OTHER}:`)) {
    return {
      reason: EXEMPT_REASONS.OTHER,
      customText: storedReason.substring(EXEMPT_REASONS.OTHER.length + 1)
    };
  }

  return {
    reason: storedReason,
    customText: ''
  };
};

export const getExemptReasonDisplay = (storedReason) => {
  const { reason, customText } = parseExemptReason(storedReason);
  
  if (reason === EXEMPT_REASONS.OTHER && customText) {
    return customText;
  }
  
  return EXEMPT_REASON_LABELS[reason] || reason || '';
};


export const getExemptReasonOptions = () => {
  return [
    ...PREDEFINED_REASONS.map(reason => ({
      value: reason,
      label: EXEMPT_REASON_LABELS[reason]
    })),
    {
      value: EXEMPT_REASONS.OTHER,
      label: EXEMPT_REASON_LABELS[EXEMPT_REASONS.OTHER]
    }
  ];
};

export const requiresCustomText = (reason) => {
  return reason === EXEMPT_REASONS.OTHER;
};
